import { defineStore } from "pinia"
import { getAction } from "@/server/request/service"
import { getListUrl } from "@/utils/queryUrl";

const useMain = defineStore('useMain', {
    state: () => {
        return {
            // 默认路由
            defaultMenu: [{
                // home page
                name: "home",
                title: "home",
                icon: '',
                path: '/home',
                component: "layouts/Basic",
                children: [
                    {
                        // home page
                        name: "homepage",
                        title: "Home",
                        icon: 'HomeOutlined',
                        path: '/home/homepage',
                        component: "home/Home",
                    },
                    {
                        // 钢筋翻样
                        name: "rebarMaterials",
                        title: "Rebar Detailing",
                        icon: 'InsertRowAboveOutlined',
                        path: "/home/rebarMaterials",
                        component: 'rebar/RebarMaterials'
                        // component: 'rebar/RevitTeachi'
                    },
                    {
                        // revit钢筋
                        name: "revit",
                        title: "Bim Plugin",
                        icon: 'InsertRowAboveOutlined',
                        path: "/home/revit",
                        component: 'revit/Revit'
                    }
                    // {
                    //     // Tkpm
                    //     name: "tkpm",
                    //     title: "About us",
                    //     icon: 'InsertRowAboveOutlined',
                    //     path: "/home/tkpm",
                    //     component: 'tkpm/Tkpm'
                    // },
                ]
            },
            {
                // 登录页
                name: "login",
                title: "登录",
                icon: '',
                path: '/login/:type',
                component: "login/Login",
                children: []
            },
            {
                // 微信登录跳转页
                name: "wecharlogin",
                title: "微信登录",
                icon: '',
                path: '/wecharlogin',
                component: "login/Test",
                children: []
            },
            ],
            // 管理员路由
            adminMenu: [{
                parent: "home",
                name: "feedBack",
                title: "反馈",
                icon: 'InsertRowAboveOutlined',
                path: "/home/feedBack",
                component: 'feedback/FeedBack'
            }],
            // 登录成功路由
            loginMenu: [{
                parent: "home",
                name: "user",
                title: "用户中心",
                icon: 'InsertRowAboveOutlined',
                path: "/home/userInfo",
                component: 'user/UserInfo'
            },
            {
                parent: "home",
                name: "pay",
                title: "会员续费",
                icon: 'InsertRowAboveOutlined',
                path: "/home/pay",
                component: 'user/UserPay'
            }],
            rebarMenu: [
                {
                    id: "home",
                    title: "Function introduction",
                    icon: "file-done",
                    url: "",
                    children: [
                        {
                            id: "home",
                            name: "home",
                            title: "Instructional videos",
                            url: ""
                        }
                    ]
                },
                {
                    id: "materials",
                    title: "Bill of Material",
                    icon: "file-done",
                    url: "",
                    children: [
                        {
                            id: "example",
                            name: "example",
                            title: "Reinforcement Detailing",
                            url: "/materials/example"
                        },
                        {
                            id: "diagrams",
                            name: "diagrams",
                            title: "Schematic management",
                            url: '/materials/diagrams',
                        },

                    ]
                },
                {
                    id: "setting",
                    title: "Option settings",
                    icon: "setting",
                    url: "",
                    children: [
                        {
                            id: "specification",
                            name: "specifications",
                            title: "Model specifications",
                            url: "/setting/specification",
                        },
                        {
                            id: "diameter",
                            name: "diameter",
                            title: "Diameter and weight",
                            url: "/setting/diameter",
                        },
                        {
                            id: "connect",
                            name: "connect",
                            title: "Connection",
                            url: "/setting/connect",
                        },
                        {
                            id: "extend",
                            name: "extend",
                            title: "Deduction settings",
                            url: "/setting/extend",
                        },
                    ]
                },
            ],
            rebarProcessingMenu: [
                {
                    id: "produce",
                    title: "Rebar Fabrication",
                    icon: "produce",
                    url: "",
                    children: [
                        {
                            id: "project",
                            name: "project",
                            title: "Project",
                            url: "/produce/project",
                        },
                        {
                            id: "team",
                            name: "team",
                            title: "Team",
                            url: "/produce/team",
                        },
                        {
                            id: "equipment",
                            name: "equipment",
                            title: "Equipment",
                            url: "/produce/equipment",
                        },
                        {
                            id: "processing",
                            name: "processing",
                            title: "Processing",
                            url: "/produce/processing",
                        },
                        {
                            id: "rawMaterial",
                            name: "rawMaterial",
                            title: "Raw material",
                            url: "/produce/rawMaterial",
                        },
                        {
                            id: "procurement",
                            name: "procurement",
                            title: "Procurement",
                            url: "/produce/procurement",
                        },
                        {
                            id: "automatic",
                            name: "automatic",
                            title: "Automatic",
                            url: "/produce/automatic",
                        },
                        {
                            id: "leftovers",
                            name: "leftovers",
                            title: "Leftovers",
                            url: "/produce/leftovers",
                        },
                    ]
                }
            ],
            rebarList: [
                {
                    id: "rebartable1",
                    appName: "rebartable1",
                    url: "",
                    pic: "http://43.142.45.115:9000/famousbuild/rebarImg/rebartable1.png",
                    state: 1,
                    description: "This is an online steel reinforcement detail table implemented on the web, which has almost all the functions of similar software on the market. It can easily and freely draw steel reinforcement styles and label angle and length information, support straight and curved lines, and accurately calculate material length. It is stable and reliable, and can provide a basic steel reinforcement data management warehouse for customized applications according to user needs. It is the core component of steel reinforcement web applications.",
                },
                {
                    id: "rebartable2",
                    appName: "rebartable1",
                    url: "",
                    pic: "http://43.142.45.115:9000/famousbuild/rebarImg/rebartable2.png",
                    state: 1,
                    description: "In the field of infrastructure construction, we have realized the identification of the content of the PDF detailed design drawings of reinforcement. For the bridge drawings in Chinese Mainland, we have adopted a feature recognition algorithm with a recognition accuracy of no less than 98%, and automatically completed the statistics of reinforcement quantity. Based on this identification technology, we can modify the local recognition adaptation rules to achieve localized application according to the drawing drawing habits of the customer's region.",
                },
                {
                    id: "rebartable3",
                    appName: "rebartable3",
                    url: "",
                    pic: "http://43.142.45.115:9000/famousbuild/rebarImg/rebartable3.png",
                    state: 1,
                    description: "A well connected data channel. Users can use our Revit or Bently plugins to import model steel bars into the steel bar table. It also supports reading Allplan's ABS format and exporting data, including exporting Excel files or JSON data and steel bar images. Through our customized development, we can overcome your bottleneck in digital steel bar applications.",
                },
                {
                    id: "rebartalbe4",
                    appName: "rebartalbe4",
                    url: "",
                    pic: "http://43.142.45.115:9000/famousbuild/rebarImg/rebartable4.jpg",
                    state: 1,
                    description: "The steel bar table provides a wealth of steel bar cutting tools, including processing calculations for gradually changing length steel bars, commonly used cutting methods to save steel bars, longitudinal steel bars for piles, etc. It provides the optimal cutting solution, which can transmit steel bar data to the intelligent processing platform to complete the processing steps of material requisition, cutting, labeling, bending, etc. Based on this system, we can customize a comprehensive intelligent processing process for customers.",
                },
            ],
            revitList: [
                {
                    id: "1",
                    appName: "",
                    url: "/home/revit",
                    pic: "http://43.142.45.115:9000/famousbuild/revit/img/revit1.png",
                    state: 1,
                    description: "The Revit Reinforcement Plugin Toolkit now has 85 commonly used functions, including reinforcement for beams, columns, walls, and slabs, as well as editing tools such as rebar breakage and hole cutting. It supports automatic generation of reinforcement joints after rebar breakage and outputs data in Excel or reinforcement forms. According to the differences in regulations among countries, we provide customized development services that are suitable for your country's standards.",
                },
                {
                    id: "2",
                    appName: "标题2",
                    url: "",
                    pic: "http://43.142.45.115:9000/famousbuild/revit/img/revit5.png",
                    state: 1,
                    description: "We provide a method for generating 3D steel bars based on beam and column plan construction drawings. Users can model local beam column nodes or insert DWG reinforcement plan drawings. The system automatically recognizes the drawings and generates 3D steel bars. Based on this technology, we can provide recognition access for construction drawings drawn according to different national standards, greatly reducing modeling time.",
                },
                {
                    id: "3",
                    appName: "标题4",
                    url: "",
                    pic: "http://43.142.45.115:9000/famousbuild/revit/img/revit2.png",
                    state: 1,
                    description: "We have established a good steel bar data ecosystem, providing various steel bar modeling tools, as well as a steel bar coding system and steel bar data output. It is compatible with Allplan and rebar formal formats and can export multiple formats. It is recommended to integrate the steel bar table system to achieve more digital applications. Usually, we need to update the steel bar coding system to comply with relevant data exchange standards based on your country or region.",
                },
                {
                    id: "4",
                    appName: "标题4",
                    url: "",
                    pic: "http://43.142.45.115:9000/famousbuild/revit/img/revit4.png",
                    state: 1,
                    description: "As you may know, Revit is more suitable for steel bar modeling of sectional and wrapped components, but lacks modeling support for flat drawings expressed by unfolding and projection methods. We provide an online modeling system outside Revit, focusing on seamless connection from flat drawings to 3D models, to meet the customized development needs of assembly and component fields.",
                }
            ],
            appList: [
                {
                    id: "tkpm1",
                    appName: "tkpm1",
                    url: "/home/tkpm",
                    pic: "http://43.142.45.115:9000/famousbuild/tkpm/TKPMhz.jpg",
                    state: 1,
                    description: "Compare etabs midas、robot， We have realized direct input of load calculation and display of calculation results in revit. For some design projects that need to be considered and modified repeatedly, this technology is indispensable. It avoids data loss and errors caused by mutual conversion between revit and professional software models, more conforms to the the first mock examination to the bottom bim idea, and effectively solves the industry pain points.",
                },
                {
                    id: "tkpm2",
                    appName: "tkpm2",
                    url: "/home/tkpm",
                    pic: "http://43.142.45.115:9000/famousbuild/tkpm/TKPMpj.jpg",
                    state: 1,
                    description: "Directly calculating in Revit has advantages over traditional methods. For example, the infill walls of a frame structure can automatically calculate the line load by setting the weight and load it onto the lower beam. For professionals, this eliminates the time-consuming steps of professional calculation software and has higher accuracy. Displaying calculation results in Revit, including internal forces, deflection, reinforcement ratio, etc., can assist users in quickly improving structures in 3D scenes.",
                },
                {
                    id: "tkpm3",
                    appName: "tkpm3",
                    url: "/home/tkpm",
                    pic: "http://43.142.45.115:9000/famousbuild/tkpm/TKPMnd.jpg",
                    state: 1,
                    description: "Supporting American standard ACI318 and Chinese standard GB50011, other standards can be customized and developed, supporting earthquake calculation and wind load calculation. Load combination can be carried out according to the requirements of the specifications. Compared with similar calculation software, the calculation difference is within 5%. Designers can usually rely on this software to complete 90% of the design work, and then import it into professional calculation software to output the final result.",
                },
                {
                    id: "tkpm4",
                    appName: "tkpm4",
                    url: "/home/tkpm",
                    pic: "http://43.142.45.115:9000/famousbuild/tkpm/home_banner_two.png",
                    state: 1,
                    description: "In addition to the overall calculation of building structure, we have provided more than 100 component design calculations in Chinese Mainland. The development and operation of such toolbox software has been more than 24 years. The website famousbuild.com has served more than 100000 users in total. In 2015, it won the Shanghai Entrepreneurship Award in China. The team started from the structural calculation software, accompanied and witnessed the rapid development of Chinese construction industry for 20 years.",
                },
            ],
            elements: [
                {
                    id: "EDAS1",
                    appName: "EDAS1",
                    url: "/home/edas",
                    pic: "http://43.142.45.115:9000/famousbuild/EDAS/edas1.png",
                    state: 1,
                    description: "Since 2016, as a partner of large petrochemical enterprises, we have been continuously researching and developing in the field of engineering data governance, supporting enterprises in carrying out data governance work. We have carried out standardization work on data at various nodes of oil extraction, refining, and sales, accumulating rich experience in developing data model management tools. Starting from data models, we have developed core modules such as data collection, data quality, data security, and data migration.",
                },
                {
                    id: "EDAS2",
                    appName: "EDAS2",
                    url: "/home/edas",
                    pic: "http://43.142.45.115:9000/famousbuild/EDAS/edas2.png",
                    state: 1,
                    description: "You cannot use a self proclaimed advanced program to demand that practitioners change their past practices. As we drive the digitalization process for oil companies with over 500000 employees, we should first learn how they did it before. The collection methods and processes we develop must be as familiar as possible within the user's knowledge system. Therefore, over the years, we have made metadata, master data, lifecycle, data compliance, and many other requirements more localized and user-friendly, which is what we can do for you.",
                },
                {
                    id: "EDAS3",
                    appName: "EDAS4",
                    url: "/home/edas",
                    pic: "http://43.142.45.115:9000/famousbuild/EDAS/edas3.png",
                    state: 1,
                    description: "Engineering historical data governance is the most common application scenario of this system. We have completed data governance work for about 60 oil extraction facilities, with an average of about 800000 to 2 million pieces of data per facility. The focus of our work is on data correction and correction. Using our self-developed quality control module, we can easily set multiple quality rules and discover errors through data format verification, association queries, and other methods, greatly improving the work efficiency of data governance personnel.",
                },
                {
                    id: "EDAS4",
                    appName: "EDAS4",
                    url: "/home/edas",
                    pic: "http://43.142.45.115:9000/famousbuild/EDAS/edas4.png",
                    state: 1,
                    description: "In 2024, this project won the Tianjin Entrepreneurship Competition Award in China.We hope that this system can be applied in more countries and projects, exchanging practices and continuously improving. As part of the promotion, we can evaluate the possibility of testing for you for free, further deploy the system for you for free, and develop some quality inspection rules. Ideally, we can complete a complete facility data collection and convert and transmit this data to multiple application system databases through data pipelines.",
                },
            ],
            windowWidth: document.body.clientWidth,
            windowHeight: document.body.clientHeight,
            userInfo: {}
        }
    },
    /**
     * 用来封装计算属性 有缓存功能  类似于computed
     */
    getters: {
        getMenuItem(state) {
            const menuItem = state.defaultMenu;
            if (Object.keys(state.userInfo).length > 0) {
                let dynamicdeMenu = menuItem[0].children.concat(state.loginMenu);
                console.log(state.userInfo.userRole == 1)
                if (state.userInfo.userRole == 1) {
                    console.log(state.adminMenu)
                    dynamicdeMenu = dynamicdeMenu.concat(state.adminMenu)
                }
                menuItem[0].children = dynamicdeMenu;
            } else {
                let removeItem = [].concat(state.loginMenu, state.adminMenu);
                let menuItemChildren = menuItem[0].children;
                for (let i = 0; i < removeItem.length; i++) {
                    for (let j = 0; j < menuItemChildren.length; j++) {
                        if (removeItem[i].name == menuItemChildren[j].name) {
                            menuItemChildren.splice(j, 1)
                        }
                    }
                }
            }
            console.log("获取当前的所有路由url:", menuItem)
            return menuItem;
        },
        getAppList(state) {
            return state.appList
        },
        getElements(state) {
            return state.elements
        },
        getUserInfo(state) {
            return state.userInfo;
        },
        getRebarMenu(state) {
            let userId = state.userInfo.userId || "15642785459862";
            state.rebarMenu.forEach(parentItem => {
                parentItem.children.forEach(item => {
                    let urlAry = item.url.split("/");
                    urlAry[urlAry.length - 1] = "userId=" + userId;
                    item.url = urlAry.join("/")
                })
            });
            return state.rebarMenu;
        }
    },
    /**
     * 编辑业务逻辑  类似于methods
     */
    actions: {
        setWindowSize(windowSizeParams) {
            this.windowWidth = windowSizeParams[0];
            this.windowHeight = windowSizeParams[1];
        },
        setAppList() {
            return new Promise((resolve, reject) => {
                if (this.appList.length == 0) {
                    getAction(getListUrl.allAppList).then(res => {
                        console.log(res)
                        if (res.success) {
                            let componentData = [];
                            let elements = [];
                            res.result.forEach((parent) => {
                                if (!parent.parentId) {
                                    parent.children = [];
                                    res.result.forEach((child) => {
                                        if (parent.id == child.parentId) {
                                            parent.children.push(child);
                                        }
                                    });
                                    if (parent.type == 1) {
                                        componentData.push(parent);
                                    } else if (parent.type == 2 || parent.type == 3) {
                                        elements.push(parent)
                                    }
                                }
                            });
                            this.appList = componentData;
                            this.elements = elements;
                            resolve()
                        } else {
                            reject(res.message)
                        }
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve()
                }
            })
        },
        // 设置用户信息
        setUserInfo(userinfo) {
            console.log("设置用户信息", userinfo)
            this.userInfo = userinfo || {};
        },
        setUserAndDynamicRouter(userinfo, router) {
            this.userInfo = userinfo || {};
            this.setDynamicRouter(router)
        },
        // 动态注册路由
        setDynamicRouter(router) {
            console.log("动态添加&&删除路由")
            let dynamicMeun = [].concat(this.loginMenu);
            if (Object.keys(this.userInfo).length > 0) {
                // 注册路由
                console.log(this.userInfo)
                if (this.userInfo.userRole == 1) {
                    dynamicMeun = dynamicMeun.concat(this.adminMenu);
                };
                console.log("添加的路由数据", dynamicMeun);
                dynamicMeun.forEach(item => {
                    let routerConfig = {
                        path: item.path,
                        name: item.name,
                        meta: { title: item.title },
                        component: () => import(`@/views/${item.component}.vue`),
                        children: []
                    }
                    if (item.parent) {
                        router.addRoute(item.parent, routerConfig)
                    } else {
                        router.addRoute(routerConfig)
                    }
                })
            } else {
                dynamicMeun = dynamicMeun.concat(this.adminMenu);
                // 删除路由
                dynamicMeun.forEach(item => {
                    router.removeRoute(item.name)
                })
            }
        },
        // 设置用户过期时间
        setUserExpirationDate(mapData) {
            for (let key in mapData) {
                this.userInfo[key] = mapData[key];
            }
        }
    }
})

export default useMain;